import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { Core } from "@faire/design-tokens";
import { CheckOutline } from "@faire/slate/icons/CheckOutline";
import { Exclamation } from "@faire/slate/icons/Exclamation";
import { Button } from "@faire/web/slate/Button";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Toast/Toast#createToast"
 */
export const AppDownloadSuccessToast: React.FC<{
  formattedPhoneNumber: string;
  onClick: () => void;
}> = (props) => {
  return (
    <Row>
      <IconWrapper>
        <CheckOutline color={Core.icon.inverse} fontSize="24px" />
      </IconWrapper>
      <Spacer width="2x" />
      <Column align="flex-start">
        <Typography color={Core.text.inverse}>
          <StrictLocalMsg
            id="hhmXIc"
            defaultMessage="Download link sent to {formattedPhoneNumber}"
            description={{
              text: "Message displayed after successfully sending app link via sms",
              img: "https://cdn.faire.com/fastly/d7b137bfac201898d639083929bf324c76128a344bbec6cdba6f59308b630dd5.png",
            }}
            values={{ formattedPhoneNumber: props.formattedPhoneNumber }}
          />
        </Typography>
        <Spacer height={4} />
        <Button
          variant="tertiary"
          tertiaryColor={Core.text.inverse}
          onClick={props.onClick}
        >
          <StrictLocalMsg
            id="TyaaRH"
            defaultMessage="Resend Link"
            description={{
              text: "Button to send a link to the user via sms again",
              img: "https://cdn.faire.com/fastly/d7b137bfac201898d639083929bf324c76128a344bbec6cdba6f59308b630dd5.png",
            }}
          />
        </Button>
      </Column>
    </Row>
  );
};

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Toast/Toast#createToast"
 */
export const AppDownloadFailureToast: React.FC<{
  onClick: () => void;
}> = (props) => {
  return (
    <Row align={!isLoggedInRetailer() ? "center" : undefined}>
      <IconWrapper $hideTryAgainButton={!isLoggedInRetailer()}>
        <Exclamation color={Core.icon.inverse} fontSize="24px" />
      </IconWrapper>
      <Spacer width="2x" />
      <Column align="flex-start">
        <Typography color={Core.text.inverse}>
          <StrictLocalMsg
            id="orW+G5"
            defaultMessage="Error sending download link."
            description={{
              text: "Message displayed after trying to send app link via sms and failing",
              img: "https://cdn.faire.com/fastly/334add1161a0c04695d2b9326b855b11d8d80c2d8469ca015755c2c19d21676c.png",
            }}
          />
        </Typography>
        {isLoggedInRetailer() ? (
          <>
            <Spacer height={4} />
            <Button
              variant="tertiary"
              tertiaryColor={Core.text.inverse}
              onClick={props.onClick}
            >
              <StrictLocalMsg
                id="N2oCB6"
                defaultMessage="Try Again"
                description={{
                  text: "Button to try sending a link to the user via sms again",
                  img: "https://cdn.faire.com/fastly/8f63db76f4e2b8b5b5d85df0eb6f7f3d36a895b7a98df0f0151d7db1e3d3c107.png",
                }}
              />
            </Button>
          </>
        ) : null}
      </Column>
    </Row>
  );
};

const IconWrapper = styled(Row).attrs({ align: "center", justify: "center" })<{
  $hideTryAgainButton?: boolean;
}>`
  flex-shrink: 0;
  ${(props) =>
    !props.$hideTryAgainButton
      ? css`
          width: ${getSpacing("5x")};
          height: ${getSpacing("5x")};
        `
      : null}
`;
